// External libraries
import styled from '@emotion/styled';

// Internal modules
import { StyledText } from '../Common';
import { HEADER_COLOR, NON_INPUT_BORDER_COLOR } from '@/styles';

const BaslButtonContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;

  @media (min-width: 376px) {
    padding: 12px 0 20px;
  }
`;

const BaslHaveAnAccountText = styled.p`
  color: ${HEADER_COLOR};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.38;
  margin-right: 32px;
`;

const BaslLogInContainer = styled.div`
  order: -1;
`;

const OrDivider = styled.div`
  border-top: 1px solid ${NON_INPUT_BORDER_COLOR};
  margin-bottom: 0.2em;
  text-align: center;
`;

const OrText = styled(StyledText)`
  background-color: white;
  bottom: 10px;
  display: inline;
  padding: 0 8px;
  position: relative;
`;

export {
  BaslButtonContainer,
  BaslHaveAnAccountText,
  BaslLogInContainer,
  OrDivider,
  OrText,
};
